import { Vue, Watch } from 'vue-property-decorator';

import { bus } from '@/main'
import { Languages } from '@/enums'

export default class GlobalMixins extends Vue {
	day: number | false = false
	month: string = '-1'
	year: number = -1
	isMobile: boolean = window.innerWidth < 768
	windowResizeStagger: boolean = false

	get userFormal(): boolean {
		return this.$store.getters.user.age === '23+'
	}
	get years () {
		const year = new Date().getFullYear()
		return Array.from({ length: year - 1900 }, (value, index) => 1901 + index).reverse()
	}
	get dayWrong(): boolean {
		if (this.day && this.day < 1) return true
		if (this.day && RegExp(/[A-Za-z]/).test((<any>this.day))) return true
		if (!this.day && (this.monthIndex !== -1 || this.year > 1900)) return true
		if (this.year === -1 && this.monthIndex === -1 && this.day && this.day > 31) return true
		if (this.year === -1 && this.monthIndex > 0 && this.day) {
			switch(this.monthIndex) {
				case 1:
				case 3:
				case 5:
				case 7:
				case 8:
				case 10:
				case 12:
					return this.day > 31
				case 4:
				case 6:
				case 9:
				case 11:
					return this.day > 31
				case 2:
					return this.day > 28
				default: 
					return false
			}
		}
		if (this.year > 1899 && this.monthIndex > 0 && this.day) return this.day > this.getLastDay({ month: this.monthIndex, year: this.year})

		return false
	}
	get monthIndex(): number {
		const numericMonth = parseInt(this.month)
		if (!isNaN(numericMonth)) {
			return numericMonth
		}
		
		switch(this.month) {
			case '-1':
				return -1
			case 'januari':
				return 1
			case 'februari':
				return 2
			case 'maart':
				return 3
			case 'april':
				return 4
			case 'mei':
				return 5
			case 'juni':
				return 6
			case 'juli':
				return 7
			case 'augustus':
				return 8
			case 'september':
				return 9
			case 'oktober':
				return 10
			case 'november':
				return 11
			case 'december':
				return 12
			default:
				return -1
		}
	}

	dayIsValid(day: number | false, month: number, year: number): boolean {
		if (!day) return false
		if (!month) return false
		if (!year) return false

		return !(day < 1 || day > this.getLastDay({month, year}))
	}
	getLastDay(timeStamp: {month: number, year: number}): number {
		let lastDayOfMonth = 0
		
		switch(timeStamp.month) {
			case 1:
			case 3:
			case 5:
			case 7:
			case 8:
			case 10:
			case 12:
				lastDayOfMonth = 31
				break
			case 4:
			case 6:
			case 9:
			case 11:
				lastDayOfMonth = 30
				break
			case 2:
				lastDayOfMonth = ((timeStamp.year % 4 == 0) && (timeStamp.year % 100 != 0)) || (timeStamp.year % 400 == 0) ? 29 : 28
				break
		}

		return lastDayOfMonth
	}
	checkTimestampValid(action: string): void {
		if (this.day !== false) {
			if (!this.dayWrong && this.dayIsValid(this.day, this.monthIndex, this.year) && this.monthIndex !== -1 && this.year !== -1) {
				this.$store.dispatch(action, { day: this.day, month: this.monthIndex, year: this.year })
		
				bus.$emit('setNextButton', 'next')
			} else {
				this.$store.dispatch(action, false)
				
				bus.$emit('setNextButton', false)
			}
		}
	}
	monthIndexToString(monthIndex: number): string {
		return monthIndex.toString()
	}

	get trimmedRouteName(): string {
		const lastIndex = this.$route.name!.lastIndexOf('-')
		if(lastIndex === -1 || this.language === Languages.NL) {
			return this.$route.name!
		}
		return this.$route.name!.slice(0, lastIndex)
	}

	get pageTexts(): any {
		return this.$store.getters.pageTexts
	}

	get language(): Languages {
		return this.$store.getters.language
	}
}
